import { ContentEmbed } from './ContentEmbed';
import { ContentError } from './ContentError';
import { ContentImagesLinks } from './ContentImagesLinks';
import { ContentItemType } from './ContentItemType';
import { ContentMultipleImages } from './ContentMultipleImages';
import { ContentRichText } from './ContentRichText';
import { ContentRichTextThreeCols } from './ContentRichTextThreeCols';
import { ContentRichTextTwoCols } from './ContentRichTextTwoCols';
import { ContentSingleImage } from './ContentSingleImage';
import { ContentSpace } from './ContentSpace';
import { ContentSubTitle } from './ContentSubTitle';
import { ContentUnknown } from './ContentUnknown';

export { ContentRichText } from './ContentRichText';
export { ContentSingleImage } from './ContentSingleImage';
export { ContentUnknown } from './ContentUnknown';
export { ContentError } from './ContentError';
export { ContentSubTitle } from './ContentSubTitle';
export { ContentRichTextTwoCols } from './ContentRichTextTwoCols';
export { ContentImagesLinks } from './ContentImagesLinks';
export { ContentRichTextThreeCols } from './ContentRichTextThreeCols';
export { ContentMultipleImages } from './ContentMultipleImages';
export { ContentEmbed } from './ContentEmbed';
export { ContentSpace } from './ContentSpace';

export type ContentItem =
  | ContentRichText
  | ContentSingleImage
  | ContentUnknown
  | ContentMultipleImages
  | ContentRichTextTwoCols
  | ContentRichTextThreeCols
  | ContentSubTitle
  | ContentError
  | ContentEmbed
  | ContentImagesLinks
  | ContentSpace;

export namespace ContentItem {
  export const getType = (model: ContentItem): ContentItemType => model.type;
}



// WEBPACK FOOTER //
// ./src/module/Model/Content/item/index.ts